import {
    AMBULANCE_DOCUMENT_USER,
    AMBULANCE_DOCUMENT_USER_SUCCESS,
    AMBULANCE_DOCUMENT_USER_ERROR,
    AMBULANCE_DOCUMENT_CODE_IGSS,
    AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS,
    AMBULANCE_DOCUMENT_CODE_IGSS_ERROR,
    AMBULANCE_DOCUMENT_PLATES,
    AMBULANCE_DOCUMENT_PLATES_SUCCESS,
    AMBULANCE_DOCUMENT_PLATES_ERROR,
    AMBULANCE_DOCUMENT_CHASIS,
    AMBULANCE_DOCUMENT_CHASIS_SUCCESS,
    AMBULANCE_DOCUMENT_CHASIS_ERROR,
    AMBULANCE_DOCUMENT_STATUS_REVIEW,
    AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS,
    AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR,
    AMBULANCE_DOCUMENT_USER_ASSIGNED,
    AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS,
    AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS,
    AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR,
    AMBULANCE_DOCUMENT_LIST,
    AMBULANCE_DOCUMENT_LIST_SUCCESS,
    AMBULANCE_DOCUMENT_LIST_ERROR,
    AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE,
    AMBULANCE_DOCUMENT_LIST_PAGE_SET,
    AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET,
    AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET,
    AMBULANCE_DOCUMENT_ASSIGN,
    AMBULANCE_DOCUMENT_ASSIGN_SUCCESS,
    AMBULANCE_DOCUMENT_ASSIGN_ERROR,
    AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET,
    AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET,
    AMBULANCE_DOCUMENT_VALIDATE,
    AMBULANCE_DOCUMENT_VALIDATE_SUCCESS,
    AMBULANCE_DOCUMENT_VALIDATE_ERROR,
    AMBULANCE_DOCUMENT_SEE_MODAL_SET,
    AMBULANCE_DOCUMENT_SEE_CHANGE_SET,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS,
    AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    user: {
        loading: false,
        userrole: 0,
        data: ''
    },
    list: {
        page: {
            current: 1,
            rows: 10
        },
        data: [],
        total_pages: 0,
        first_page: 0,
        last_items: 0,
        total_item: 0,
        summary: { pending: 0, approved: 0, rejected: 0, total: 0 }
    },
    search: {
        modal: false,
        init: true,
        data: {
            plate: '',
            chasis: '',
            statusreview: '',
            userassigned: '',
            codeigss: ''
        }
    },
    plates: { loading: false, data: [] },
    codeigss: { loading: false, data: [] },
    chasis: { loading: false, data: [] },
    statusreview: { loading: false, data: [] },
    userassigned: { loading: false, data: [] },
    usersforassign: { loading: false, data: [] },
    assign: {
        modal: false,
        data: {}
    },
    validate: {
        modal: false,
        data: {}
    },
    seedocument: {
        modal: false,
        data: {}
    },
    error: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case AMBULANCE_DOCUMENT_USER:
            return { ...state, user: { ...state.user, loading: true } };
        case AMBULANCE_DOCUMENT_USER_SUCCESS:
            return { ...state, user: { loading: false, userrole: action.payload.userrole, data: action.payload.data } };
        case AMBULANCE_DOCUMENT_USER_ERROR:
            return { ...state, user: { ...state.user, loading: false } };

        case AMBULANCE_DOCUMENT_CODE_IGSS:
            return { ...state, codeigss: { ...state.codeigss, loading: true } };
        case AMBULANCE_DOCUMENT_CODE_IGSS_SUCCESS:
            return { ...state, codeigss: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_CODE_IGSS_ERROR:
            return { ...state, codeigss: { ...state.codeigss, loading: false } };

        case AMBULANCE_DOCUMENT_PLATES:
            return { ...state, plates: { ...state.plates, loading: true } };
        case AMBULANCE_DOCUMENT_PLATES_SUCCESS:
            return { ...state, plates: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_PLATES_ERROR:
            return { ...state, plates: { ...state.plates, loading: false } };

        case AMBULANCE_DOCUMENT_CHASIS:
            return { ...state, chasis: { ...state.chasis, loading: true } };
        case AMBULANCE_DOCUMENT_CHASIS_SUCCESS:
            return { ...state, chasis: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_CHASIS_ERROR:
            return { ...state, chasis: { ...state.chasis, loading: false } };

        case AMBULANCE_DOCUMENT_STATUS_REVIEW:
            return { ...state, statusreview: { ...state.statusreview, loading: true } };
        case AMBULANCE_DOCUMENT_STATUS_REVIEW_SUCCESS:
            return { ...state, statusreview: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_STATUS_REVIEW_ERROR:
            return { ...state, statusreview: { ...state.statusreview, loading: false } };

        case AMBULANCE_DOCUMENT_USER_ASSIGNED:
            return { ...state, userassigned: { ...state.userassigned, loading: true } };
        case AMBULANCE_DOCUMENT_USER_ASSIGNED_SUCCESS:
            return { ...state, userassigned: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_USER_ASSIGNED_ERROR:
            return { ...state, userassigned: { ...state.userassigned, loading: false } };

        case AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN:
            return { ...state, usersforassign: { ...state.usersforassign, loading: true } };
        case AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_SUCCESS:
            return { ...state, usersforassign: { loading: false, data: action.payload } };
        case AMBULANCE_DOCUMENT_USERS_FOR_ASSIGN_ERROR:
            return { ...state, usersforassign: { ...state.usersforassign, loading: false } };

        case AMBULANCE_DOCUMENT_LIST:
            return { ...state, loading: true };
        case AMBULANCE_DOCUMENT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            };
        case AMBULANCE_DOCUMENT_LIST_ERROR:
            return { ...state, loading: false, error: true };
        case AMBULANCE_DOCUMENT_LIST_SEARCH_CHANGE:
            return { ...state, search: { ...state.search, data: action.payload } };
        case AMBULANCE_DOCUMENT_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload
                    }
                }
            };

        case AMBULANCE_DOCUMENT_ASSIGN_MODAL_SET:
            return { ...state, assign: { ...state.assign, modal: action.payload } };
        case AMBULANCE_DOCUMENT_ASSIGN_CHANGE_SET:
            return { ...state, assign: { ...state.assign, data: action.payload } };
        case AMBULANCE_DOCUMENT_ASSIGN:
            return { ...state, loading: true };
        case AMBULANCE_DOCUMENT_ASSIGN_SUCCESS:
            return { ...state, loading: false, assign: { modal: false, data: {} } };
        case AMBULANCE_DOCUMENT_ASSIGN_ERROR:
            return { ...state, loading: false };

        case AMBULANCE_DOCUMENT_VALIDATE_MODAL_SET:
            return { ...state, validate: { ...state.validate, modal: action.payload } };
        case AMBULANCE_DOCUMENT_VALIDATE_CHANGE_SET:
            return { ...state, validate: { ...state.validate, data: action.payload } };
        case AMBULANCE_DOCUMENT_VALIDATE:
            return { ...state, loading: true };
        case AMBULANCE_DOCUMENT_VALIDATE_SUCCESS:
            return { ...state, loading: false, validate: { modal: false, data: {} } };
        case AMBULANCE_DOCUMENT_VALIDATE_ERROR:
            return { ...state, loading: false };

        case AMBULANCE_DOCUMENT_SEE_MODAL_SET:
            return { ...state, seedocument: { ...state.seedocument, modal: action.payload } };
        case AMBULANCE_DOCUMENT_SEE_CHANGE_SET:
            return { ...state, seedocument: { ...state.seedocument, data: action.payload } };
        case AMBULANCE_DOCUMENT_SEE_DOCUMENT:
            return { ...state, loading: true };
        case AMBULANCE_DOCUMENT_SEE_DOCUMENT_SUCCESS:
            return { ...state, loading: false, seedocument: { ...state.seedocument, data: action.payload } };
        case AMBULANCE_DOCUMENT_SEE_DOCUMENT_ERROR:
            return { ...state, loading: false };

        default:
            return { ...state };
    }
};
